var map = {
	"./ar.json": 65638,
	"./cn.json": 9231,
	"./de.json": 89810,
	"./es.json": 54392,
	"./fr.json": 78236,
	"./hu.json": 12262,
	"./id.json": 33440,
	"./ir.json": 74905,
	"./it.json": 4152,
	"./jp.json": 81274,
	"./ko.json": 70778,
	"./pl.json": 45752,
	"./pt.json": 5287,
	"./ru.json": 65865,
	"./tr.json": 95509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25391;